import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import CircularText from "./CircularText";
export default function FooterContactForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const formRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Only alphabets for first & last name
    if (name === "firstName" || name === "lastName") {
      if (!/^[a-zA-Z\s]*$/.test(value)) return;
    }

    // Only numbers for phone
    if (name === "phone") {
      if (!/^[0-9]*$/.test(value)) return;
    }

    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required";

    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }

    return newErrors;
  };

 const handleSubmit = (e) => {
  e.preventDefault();

  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  emailjs
    .sendForm(
      "service_dle3i2d",
      "template_kg14f8p",
      formRef.current,
      "HodQHwE7PQcV2do4q"
    )
    .then(() => {
      alert("Message sent successfully!");

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    })
    .catch((error) => {
      console.log(error);
      alert("Failed to send message.");
    });
};


  const handleOpenResume = () => {
    window.open("/Divyasri_Kandavalli_Resume.pdf", "_blank");
  };

  return (
    <section
      className="relative bg-transparent py-10  xl:py-28  overflow-hidden"
      id="contact"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 xs:gap-10 sm:gap-20 px-8 2xl:px-0 items-center">
        {/* LEFT CONTENT */}
        <div className="text-[#F8F8F8]">
          <p className="flex items-center gap-2 text-[16px] font-medium leading-[1.4em] mb-4">
            <span className="w-2.5 h-2.5 rounded-full bg-[#86ff9f]" />
            Contact Me
          </p>

          <h2 className="text-[24px] md:text-[32px] xl:text-[42px] font-semibold leading-[1.2em] text-[#F8F8F8]">
            Let’s build something <br />
            <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
              great together
            </span>
          </h2>

          <p className="mt-6 text-[#f8f8f8] text-[16px] font-normal leading-[1.4em]">
            Have a project idea or need help with web development? Feel free to
            reach out. I’m always open to discussing new opportunities,
            collaborations, and freelance projects.
          </p>

          {/* CONTACT INFO */}
          <div className="mt-10 relative">
            {/* Address */}
            <div className="flex gap-4 items-start mb-4 xl:mb-8">
              <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] flex items-center justify-center text-[#0C1F20]">
                <LocationOnOutlinedIcon />
              </div>

              <div>
                <p className="text-[#f8f8f8] text-[18px] xl:text-[20px] font-semibold mb-[5px] leading-[1.2em]">
                  Address
                </p>
                <p className="text-[#f8f8f8] text-[14px] xl:text-[16px] leading-[1.6em] max-w-[320px]">
                  Hyderabad, Telangana India - 500084
                </p>
              </div>
            </div>

            {/* Phone */}
            {/* <div className="flex gap-4 items-center">
              <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] flex items-center justify-center text-[#0C1F20]">
                <CallOutlinedIcon />
              </div>

              <div>
                <p className="text-[#f8f8f8] text-[18px] xl:text-[20px] font-semibold mb-[5px] leading-[1.2em]">
                  Phone Number
                </p>

                <a
                  href="tel:+919110385435"
                  className="text-[#f8f8f8] text-[14px] xl:text-[16px] leading-[1.6em]"
                >
                  +91 9110385435
                </a>
              </div>
            </div> */}

            {/* Right side circular placeholder (alignment only) */}
            <div
              onClick={handleOpenResume}
              className="xs:hidden sm:block absolute right-0 top-28 xl:top-1/2 -translate-y-1/2 cursor-pointer"
            >
              <CircularText
                text="VIEW MY RESUME * VIEW MY RESUME *"
                spinDuration={20}
              />
            </div>
          </div>
        </div>

        {/* RIGHT FORM CARD */}
        <div
          className="relative bg-white/5 backdrop-blur-xl rounded-3xl p-4 xl:p-10 border border-white/10"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <p className="text-[#F8F8F8] font-normal text-[14px] xl:text-[16px] mb-6">
            Send me a message and I’ll get back to you soon to discuss your
            project, collaboration, or development requirements.
          </p>

          <form ref={formRef} className="space-y-5" onSubmit={handleSubmit} noValidate>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="input"
                />
                {errors.firstName && (
                  <p className="text-red-400 text-sm mt-1">
                    {errors.firstName}
                  </p>
                )}
              </div>

              <div>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="input"
                />
                {errors.lastName && (
                  <p className="text-red-400 text-sm mt-1">{errors.lastName}</p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-[14px] xl:text-[16px]">
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="input"
                />
                {errors.email && (
                  <p className="text-red-400 text-sm mt-1">{errors.email}</p>
                )}
              </div>

              <div>
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  maxLength={10}
                  className="input"
                />
                {errors.phone && (
                  <p className="text-red-400 text-sm mt-1">{errors.phone}</p>
                )}
              </div>
            </div>

            <textarea
              rows="5"
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              className="input resize-none"
            />

            <button
              type="submit"
              className="
    mt-4 px-8 py-3 xl:py-5 rounded-full text-[#163031]
    font-semibold text-[16px]
    bg-[linear-gradient(90deg,#6cfcb5,#F0FF6C,#6cfcb5)]
    bg-[length:200%_100%]
    bg-left
    transition-all duration-500 ease-in-out
    hover:bg-right
  "
            >
              Submit Message
            </button>
          </form>
        </div>
      </div>

      {/* GRID OVERLAY */}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="w-full h-full bg-[linear-gradient(rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:80px_80px]" />
      </div>
    </section>
  );
}
